import React from 'react';
import {deleteEvent} from '../Services/CallService';
import {Link} from "react-router-dom";
import DataTable from "react-data-table-component";
import SortIcon from "@mui/icons-material/ArrowDownward";
import VisibilityIcon from '@mui/icons-material/Visibility';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import FilterEventToggle from "./FilterEventToggle"
import {useFilter} from "../Contexts/FilterContext"
import TimeConflicts from "./TimeConflicts"
import {useData} from  "../Contexts/DataContext"


function EventComponent(props) {
    const filterData = useFilter()
    const collector = useData()
    const [data, setData] = React.useState({
      events: collector.data,
      role: collector.user.userType,
      email: collector.user.email,
  })
  const customStyles = {
    rows: {
      style: {
        paddingLeft: "0px", // override the cell padding for head cells
        paddingRight: "0px",
        borderRadius: "0px",
      },
    },
    headCells: {
      style: {
        paddingLeft: "3px", // override the cell padding for head cells
        paddingRight: "3px",
        fontFamily: "Avenir Next",
        fontStyle: "semibold",
        fontSize: "11px",
      },
    },
    cells: {
      style: {
        paddingLeft: "3px", // override the cell padding for data cells
        paddingRight: "3px",
        fontFamily: "Avenir Next",
      },
    },
  };

      const columns = [
        {
          name: "EVENT NAME",
          selector: (e) => e.eventName,
          sortable: true,
          maxWidth: "150px"
        },
        {
          name: "HOST",
          selector: (e) => e.host,
          sortable: true,
          maxWidth: "200px"
        },
        {
          name: "TIME",
          selector: (e) => e.time,
          sortable: true,
          maxWidth: "15px"
        },
        {
            name: "DATE",
            selector: (e) => e.date,
            sortable: true,
            maxWidth: "15px"
          },
        {
          name: "LOCATION",
          selector: (e) => e.location,
          sortable: true,
          maxWidth: "200px"
        },
        {
          name: "DESCRIPTION",
          selector: (e) => e.description,
          sortable: true,
          maxWidth: "200px"
        },
        {
          name: "ACTIONS",
          sortable: false,
          maxWidth: "15px",
          cell: (event) => [
              <>
              <div>
              <div>
                <Link className='mx-[5px]'
                    to={`/DisplayEvent/${event.eventID}`}> 
                    <VisibilityIcon fontSize="small" style={{ color: '#5A5A5A' }}/>
                </Link>
                </div>
              </div>
              <div>
              <Link className='mx-[5px]'
                  to={`/EditEvent/${event.eventID}`}> 
                  <EditIcon fontSize="small" style={{ color: '#5A5A5A' }}/>
              </Link>
              </div>
              <div>
              <button id={event.eventID} className='mx-[5px]' onClick={async (e) => {
                  await deleteEvent(e.currentTarget.getAttribute("id"), event.host, data.role, data.email)
                  await collector.refresh()
              }}> 
                <DeleteIcon fontSize="small" style={{ color: '#5A5A5A' }}/>
              </button>
              </div>
              </>
      
          ]
        }
    ]
      function filterAttendee(event) {
          if (event.attendees === null) {
            return false
          }
          let attendeePresent = false;
          event.attendees.map((e) => {
            if (data.email === e.email) {
              attendeePresent = true;
            }
          })
          return attendeePresent
      }

      function displayData() {
          
          if (props.my == false) { 
            return <DataTable
            customStyles={customStyles}
            columns={columns}
            data={filterData.filter != undefined ? filterData.filter: data.events}
            defaultSortField="title"
            sortIcon={<SortIcon />}	
            striped
            pagination
            responsive	
          />
          } else { 
            return (<><DataTable
            customStyles={customStyles}
            columns={columns}
            data={JSON.parse(JSON.stringify(data.events)).filter((event) => (filterAttendee(event)))}
            defaultSortField="title"
            sortIcon={<SortIcon />}	
            striped
            pagination
            responsive	
          />
          <TimeConflicts events={JSON.parse(JSON.stringify(data.events)).filter((event) => (filterAttendee(event)))}/>
          </>);
        }
      }

    return (
        <div>
            {props.my == false && <FilterEventToggle data={data.events}/>}
            {displayData()}
        </div>
    )
}

export default EventComponent;